export const modifyA = (state, name) => {
    state.resName = name;
}

export const modifyB = (state, name) => {
    state.resName = name;
}